/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/eventDetail.config.json";

import {VApplication} from "../../../application";
import { AppNavigatorService } from "../../appNavigatorService";

const getWhoamiSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.AppNavigatorService") as AppNavigatorService;
};

export interface ISettingsMethods extends IPluginMethodMap {
  getSettingsProps(args: any): Promise<any>;
}

export class SettingsService implements IAgentPlugin {
  readonly methods: ISettingsMethods;

  constructor() {
    this.methods = {
      getSettingsProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    return {
      buttons:await this.getButtons(config?.buttons)
    };
  }

  private async getButtons(data: any) {
    let whoami = await getWhoamiSrv()?.whoAmI();
    if (whoami?.whoami === "RISK_CAPITAL") {
      return config?.buttons;
    } else{
      return [];
    }
  }
}
